<template>
  <b-dropdown
    v-if="languages.length > 1"
    aria-role="list"
    :mobile-modal="false"
    :scrollable="true"
    :max-height="210"
    position="is-top-left"
  >
    <template #trigger>
      <p class="is-inline-flex has-items-aligned-center has-col-gap-50">
        <country-flag :country-code="getLocaleCountryCode(activeLocaleCode)" />
        <u-link :key="activeLocaleCode">{{ activeLanguage }}</u-link>
      </p>
    </template>

    <b-dropdown-item
      v-for="{ code, language } of languages"
      :key="code"
      :disabled="code === activeLocaleCode"
      aria-role="listitem"
      @click="setLanguage(code)"
    >
      <country-flag
        :country-code="getLocaleCountryCode(code)"
        class="has-margin-right-25"
      />
      {{ language }}
    </b-dropdown-item>
  </b-dropdown>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { getLocaleCountryCode } from "@/data/enums/i18n";
import type { IState } from "@/store";

export default defineComponent({
  name: "BrandLanguageSelector",
  computed: {
    languages() {
      return this.$_.orderBy(
        (this.$store.state as IState)?.brand?.languages || [],
        ["language"],
        ["asc"]
      );
    },
    activeLocaleCode() {
      return this.$store.state?.i18n?.activeLocaleCode;
    },
    activeLanguage() {
      return this.$_.find(this.languages, ["code", this.activeLocaleCode])
        ?.language;
    }
  },
  methods: {
    async setLanguage(code: string) {
      await this.$store.dispatch("i18n/setLanguage", code, { root: true });
      this.$store.dispatch("toast/show", {
        message: this.$t("_.language_changed"),
        position: "is-bottom"
      });
    },
    getLocaleCountryCode(code: string) {
      return getLocaleCountryCode(code);
    }
  }
});
</script>
